import { useAuth0 } from "@auth0/auth0-react";
import { CloudImage } from "@fluidattacks/design";
import { useCallback, useContext } from "react";
import * as React from "react";

import { FormButton } from "./styles";
import type { IProvider } from "./types";

import { useAudit } from "hooks/use-audit";
import { cliOauthCallbackUri, cliOauthContext } from "utils/cli-oauth";

const LoginProvider: React.FC<IProvider> = ({
  auth0Connection,
  imageAlt,
  imageId,
  name,
  section,
}: IProvider): JSX.Element => {
  const { loginWithRedirect } = useAuth0();
  const { addAuditEvent } = useAudit();
  const isCliOauth = useContext(cliOauthContext);

  const handleProviderLogin = useCallback((): void => {
    addAuditEvent(section, name);
    // In the CLI login flow, return to the CLI callback instead of the web one.
    const redirectOverride = isCliOauth
      ? // eslint-disable-next-line camelcase -- Auth0 SDK property
        { redirect_uri: cliOauthCallbackUri() }
      : {};
    void loginWithRedirect({
      authorizationParams: { connection: auth0Connection, ...redirectOverride },
    });
  }, [
    addAuditEvent,
    auth0Connection,
    isCliOauth,
    loginWithRedirect,
    name,
    section,
  ]);

  return (
    <FormButton key={imageAlt} onClick={handleProviderLogin}>
      <CloudImage alt={imageAlt} publicId={imageId} width={"24px"} />
      {`Continue with ${name}`}
    </FormButton>
  );
};

export { LoginProvider };
